import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {DadosUsuarioService} from 'src/app/services/dados-usuario.service';
import {Subject} from 'rxjs';
import { AlertRefazerRotaComponent } from './alert-refazer-rota/alert-refazer-rota.component';
import { AlertSucessoAprovacaoComponent } from './alert-sucesso-aprovacao/alert-sucesso-aprovacao.component';
import { AlertPerguntaComponent } from './alert-pergunta/alert-pergunta.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-dados-usuario-rota-inteligente',
    templateUrl: './dados-usuario-rota-inteligente.component.html',
    styleUrls: ['./dados-usuario-rota-inteligente.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AlertRefazerRotaComponent, AlertSucessoAprovacaoComponent, AlertPerguntaComponent, LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, BreadcrumbComponent, FooterComponent, AppDatePipe]
})

export class DadosUsuarioRotaInteligenteComponent implements OnInit, OnDestroy {

  idEmpresaLogada: any = localStorage.idEmpresaLogada;
  idUsuario: number;
  dadosRotaInteligente: any = null;
  showAlertRefazerRota: boolean = false;
  showAlertSucessoAprovacao: boolean = false;
  detalheRoteirizacao: any = null;
  alertLoading: boolean = false;
  alertPergunta: boolean = false;
  mensagemErroRotaInteligente: string = '';
  private readonly $destroy = new Subject<void>();

  constructor(
    private readonly service: DadosUsuarioService,
    public rotaAtiva: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.rotaAtiva.params
    .pipe(takeUntil(this.$destroy))
    .subscribe((data: any) => {
      this.idUsuario = data.idUsuario;
      this.consultaSeUsuarioTemRotaInteligente();
    });
  }

  consultaSeUsuarioTemRotaInteligente() {
    this.service.checkUserHasRotaInteligente(this.idEmpresaLogada, this.idUsuario).pipe(takeUntil(this.$destroy)).subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          if (response.response.possuiRoteirizacao === true) {
            this.consultaDadosRotaInteligente();
          } else {
            this.dadosRotaInteligente = undefined;
          }
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.dadosRotaInteligente = false;
      }
    });
  }

  consultaDadosRotaInteligente() {

    this.service
    .getDataRotaInteligente(this.idEmpresaLogada, this.idUsuario)
    .pipe(takeUntil(this.$destroy))
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.dadosRotaInteligente = response.response;
          let i = 0;
          this.dadosRotaInteligente.forEach(rota => {
            if (rota.status === 'FINALIZADO') {
              i++;
            }
          });
        } else {
          this.dadosRotaInteligente = undefined;
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }


  consultaDadosRoteirizacao(idRoteirizacao: number) {
    this.showAlertRefazerRota = true;
    this.service.getDetalhesRotaInteligente(this.idEmpresaLogada, this.idUsuario, idRoteirizacao)
    .pipe(takeUntil(this.$destroy))
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.detalheRoteirizacao = response.response;
        } else {
          this.detalheRoteirizacao = false;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.detalheRoteirizacao = false;
      }
    });
  }

  // A partir daqui vem o click no botão chamando o ALERT REFAZER ROTA, e suas próximas ações

  // INICIO REFAZER ROTA
  // Primeiro Consulta o Excedente
  clickRefazerRota() {
    this.alertLoading = true;

    this.service.consultaExcedente(this.idEmpresaLogada)
    .pipe(takeUntil(this.$destroy))
    .subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        if (response.status === 'OK') {
          if (response.response.consultaExcedente === false) {
            this.consultaDetalheRoteirizacao();
          } else {
            this.mensagemErroRotaInteligente = '';
            this.alertPergunta = true;
          }
        } else {
          this.mensagemErroRotaInteligente = 'Ocorreu um erro. Por favor tente mais tarde.';
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.alertLoading = false;
        this.mensagemErroRotaInteligente = erro.error.mensagem;
      }
    });
  }

  consultaDetalheRoteirizacao() {

    this.showAlertRefazerRota = true;

    this.service.getDetailRoteirizacao('REFAZER ROTEIRIZACAO', this.idEmpresaLogada, this.idUsuario)
    .pipe(takeUntil(this.$destroy))
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.detalheRoteirizacao = response.response;
        } else {
          this.detalheRoteirizacao = false;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.detalheRoteirizacao = false;
      }
    });
  }

  // FIM REFAZER ROTA

  eventoAlertRefazerRota(acao: string) {
    if (acao === 'fechar') {
      this.showAlertRefazerRota = false;
      this.consultaDadosRotaInteligente();
    } else {
      this.showAlertRefazerRota = false;
      this.alertLoading = true;
      this.aprovarRoteirizacao();
    }
  }

  aprovarRoteirizacao() {
    this.service.approvesRoteirizacao(this.idEmpresaLogada, this.detalheRoteirizacao.idRoteirizacao)
    .pipe(takeUntil(this.$destroy))
    .subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        this.mensagemErroRotaInteligente = '';

        if (response.status === 'OK') {
          this.consultaDadosRotaInteligente();
          this.showAlertSucessoAprovacao = true;
        } else {
          this.mensagemErroRotaInteligente = 'Ocorreu um erro na aprovação de rota inteligente, por favor tente mais tarde.';
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.alertLoading = false;
        this.mensagemErroRotaInteligente = erro.error.mensagem;
      }
    });
  }

  eventoAlertSucessoAprovacaoFechou(evento: string) {
    this.showAlertSucessoAprovacao = false;
  }

  eventoAlertPergunta(acao: string) {

    this.alertPergunta = false;
    if (acao === 'confirmar') {
      this.consultaDetalheRoteirizacao();
    }

  }

  goBackPage() {
    window.history.back();
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

}
